import { action } from 'satcheljs';
import { addCoreDatapointConfig } from 'owa-analytics-actions';
import type { MailboxInfo } from 'owa-client-types';

export default action('MIGRATE_OUTLOOK_FAVORITES', (mailboxInfo: MailboxInfo) =>
    addCoreDatapointConfig({ name: 'MigrateOutlookFavorites' }, { mailboxInfo })
);
